// Guard for hydrating a server-restored draft state (?rk_draft deep link).
//
// The save-draft POST embeds the mounted product's gid inside the state
// envelope; on resume the lookup returns that envelope verbatim. This
// guard is the one place that decides whether a returned envelope is safe
// to feed into the customiser's setters: it must be a real object, carry
// a spots array, and belong to the SAME product as the mounted PDP. A
// mismatch (link followed on a different product, tampered payload,
// malformed row) returns null and the caller ignores it silently - the
// customer just gets the normal fresh flow.
//
// Pure + structurally typed so it runs under the node vitest project
// without dragging App.tsx's DOM-coupled types in.

export type RestorableEnvelope = {
  spots?: unknown;
  productGid?: unknown;
};

export function guardRestoredState<T extends RestorableEnvelope>(
  raw: T | null | undefined,
  productGid: string,
): T | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
  if (!Array.isArray(raw.spots)) return null;
  if (!productGid || raw.productGid !== productGid) return null;
  return raw;
}
